var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { CART, ORDER, RECENT_ORDERS, MENU_ITEMS, ACCOUNT_CHECKOUT } from '@/stores/defs';
import { SUCCESS_MSG } from "@/common/messages/success.msg";
import { ERROR_MSG } from "@/common/messages/error.msg";
import EventBus from '@EventBus';
import orderService from '@/services/order.service';
import cartMixin from '@Mixin/cartMixin';
import serviceMixin from '@Mixin/serviceMixin';
import paymentMixin from '@Mixin/paymentMixin';
import addressMixin from '@Mixin/addressMixin';
import contactDetailsMixin from '@Mixin/contactDetailsMixin';
import trackerMixin from '@Mixin/trackerMixin';
import locationsMixin from '@Mixin/locationsMixin';
import webSocketMixin from '@Mixin/webSocketMixin';
import accountMixin from '@Mixin/accountMixin';
import navigationMixin from '@Mixin/navigationMixin';
import notificationMixin from '@Mixin/notificationMixin';
import EOrderStatus from '@Interface/Orders/EOrderStatus';
import * as moment from 'moment-timezone';
import DateManipulator from '@/utils/DateManipulator';
var storeIcon = require('@/assets/store-notification-icon.png');
var orderMixin = {
    mixins: [
        serviceMixin,
        paymentMixin,
        addressMixin,
        contactDetailsMixin,
        cartMixin,
        trackerMixin,
        locationsMixin,
        webSocketMixin,
        notificationMixin,
        accountMixin,
        navigationMixin,
    ],
    computed: __assign({}, mapGetters({
        cartItems: CART.ITEMS,
        getOrderFromStore: ORDER.GET_ORDER,
        getActiveOrder: RECENT_ORDERS.GET_ACTIVE_ORDER,
        getDelayTime: ORDER.GET_DELAY_TIME,
        getDelayType: ORDER.GET_DELAY_TYPE,
        menuId: MENU_ITEMS.GET_MENU_ID,
        userInstructions: ACCOUNT_CHECKOUT.GET_USER_INSTRUCTIONS,
        orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME
    }), { displayOrderId: function () {
            var order = this.getOrder;
            if (!order) {
                return;
            }
            var orderId = order.id;
            var padder = "0";
            var splitId = orderId.substr(orderId.indexOf("-") + 1).slice(-4);
            return padder.repeat(4 - splitId.length) + splitId;
        },
        getServiceUsed: function () {
            var order = this.getOrder;
            var serviceType = order && +order.serviceType;
            return serviceType;
        },
        resolveMapOrigin: function () {
            // TODO resolve map origin
            return null;
        },
        getOrder: function () {
            var order = this.getOrderFromStore;
            if (!order) {
                var activeOrder = this.getActiveOrder;
                if (!activeOrder) {
                    return null;
                }
                // cleanup API
                var customer = this.customer;
                if (customer) {
                    customer['hydrationStrategy'] = 'hydrateFromStore';
                    activeOrder['customer'] = this.customer;
                }
                this.setOrder(activeOrder);
            }
            order = this.getOrderFromStore;
            return order || null;
        },
        getOrderDestination: function () {
            var order = this.getOrder;
            if (!order) {
                return;
            }
            var isDelivery = order.isDelivery();
            if (isDelivery) {
                var delivery = order.delivery;
                var address = delivery.getFormattedAddress();
                return address;
            }
            var storeName = this.storeName;
            var storeLocality = this.storeLocality;
            var destination = storeName + ", " + storeLocality;
            return destination;
        },
        isOrderDelivery: function () {
            var order = this.getOrder;
            if (!order) {
                return false;
            }
            var isDelivery = order.isDelivery();
            return isDelivery;
        } }),
    methods: __assign({}, mapActions({
        setOrder: ORDER.SET_ORDER,
        setDelayTime: ORDER.SET_DELAY_TIME,
        setDelayType: ORDER.SET_DELAY_TYPE,
        setActiveOrder: RECENT_ORDERS.SET_ACTIVE_ORDER,
    }), { redirectToSignIn: function () {
            if (this.isNoLogin) {
                this._setBackRoute({
                    path: '/checkout'
                });
                this._navigateToSignIn();
                return true;
            }
            return false;
        },
        getOrderFromService: function () {
            if (this.isGuest) {
                return orderService.getGuestOrder(this.orderId, this.lb, this.guestId);
            }
            return orderService.getOrder(this.orderId, this.lb);
        },
        placeOrder: function (order) {
            if (this.redirectToSignIn()) {
                return;
            }
            var callback = this._orderSuccessfulResponse;
            var errorCallback = this._orderErrorResponse;
            orderService.sendOrder(order).then(callback).catch(errorCallback);
        },
        _orderSuccessfulResponse: function (response) {
            // TODO remove message check, replace with HTTP status code
            var data = response.data || { body: null };
            var body = data.body || null;
            var message = data.message || ERROR_MSG.ORDER.SERVER_ERR;
            if (message === SUCCESS_MSG.ORDER.PROCESSED) {
                this.clearCart();
                EventBus.$emit('order-success', body);
                this.setOrder(body);
                var order = this.getOrderFromStore;
                this.setActiveOrder(order);
                this._resetTrackerPosition();
                return;
            }
            var errorMessage = '';
            var contactError = message.includes("couldn't contact");
            if (contactError) {
                var contactPhone = this.location.contactPhone;
                errorMessage = ERROR_MSG.LOCATION.UNAVAILABLE(contactPhone);
            }
            else {
                errorMessage = message;
            }
            EventBus.$emit('order-error', errorMessage);
        },
        _orderErrorResponse: function (error) {
            EventBus.$emit('order-error', error);
        },
        validateOrder: function (order) {
            var valid = true;
            var error = "";
            if (order.items.length === 0) {
                valid = false;
                error = "no items in cart";
            }
            return {
                isOrderValid: valid,
                order: order,
                error: error,
            };
        },
        getOrderDelay: function () {
            var deltaSeconds = moment().tz(this.location.timeZone).diff(this.orderTime, 'seconds');
            if (deltaSeconds !== 0) {
                deltaSeconds *= -1;
            }
            return {
                pd: deltaSeconds,
                pdt: 3,
            };
        },
        createOrder: function () {
            var order = {
                a: this.getSelectedPaymentId,
                items: this.cartItems,
                serviceType: this.getServiceType,
                deliveryAddress: { id: this.getSelectedAddressId },
                preorder: this.preorder,
                customer: this.userId,
                lb: this.location.id,
                m: this.menuId,
                userInstructions: this.userInstructions
            };
            var delayTime = (this.getDelayTime > 900); // over 15 min TODO make this configuration
            var isDelayed = !DateManipulator.isTimeASAP(this.orderTime);
            if (delayTime && isDelayed) {
                order['delay'] = this.getOrderDelay();
            }
            return this.validateOrder(order);
        },
        startTrackerWebSocket: function (location, order) {
            var orderId = order.id;
            var orderStatus = order.status;
            var secureConnection = location.pushSecure;
            var wsProtocol = (secureConnection) ? 'wss' : 'ws';
            var host = location.pushHost;
            var port = location.pushPort;
            var wsUrl = wsProtocol + "://" + host + ":" + port + "/wspush/ois-" + orderId;
            var websocket;
            try {
                websocket = new WebSocket(wsUrl);
            }
            catch (error) {
                console.error(error);
                return;
            }
            var vue = this;
            this.setSocket({
                websocket: websocket,
                orderId: orderId,
                responseHandler: function (response) {
                    vue.handleResponseWebSocket(response, orderStatus);
                }
            });
        },
        initializeTrackerWebSocket: function () {
            var _this = this;
            setTimeout(function () {
                var order = _this.getOrder;
                if (!order) {
                    return;
                }
                var locationBase = order.locationBase;
                var locationPromise = _this.getLocationFromBase(locationBase);
                var vue = _this;
                locationPromise.then(function (location) {
                    vue.startTrackerWebSocket(location, order);
                });
            }, 2000); //hacky
        },
        handleResponseWebSocket: function (response, orderStatus) {
            var notify = response.notify;
            if (notify !== "notify_push_order_items_status") {
                return;
            }
            var lineItemStatus = parseFloat(response.object.line_item_status);
            // never go down
            if (orderStatus <= lineItemStatus) {
                this.setTrackerPosition(lineItemStatus);
            }
            var serviceType = this.getServiceType;
            this.sendNotificationOnReady(lineItemStatus, serviceType);
            if (lineItemStatus === EOrderStatus.STATUS_DELIVERED) {
                // remove active order as it has been delivered
                this.setTrackerPosition(lineItemStatus);
                var activeOrder = this.activeOrder;
                if (!activeOrder) {
                    this.setActiveOrder(null);
                }
                this.closeSocket();
            }
        },
        sendNotificationOnReady: function (status) {
            var isPickup = this.isForPickup;
            var isDelivery = this.isForDelivery;
            if (isPickup && status === EOrderStatus.STATUS_STAGED) {
                this.triggerNotification("Great news!", SUCCESS_MSG.ORDER.STATUS.PICKUP_READY, storeIcon);
                return;
            }
            if (isDelivery && status === EOrderStatus.STATUS_ON_ROUTE) {
                this.triggerNotification("Great news!", SUCCESS_MSG.ORDER.STATUS.ON_ITS_WAY, storeIcon);
            }
        },
        _getOrderConfirmationRoute: function (isMobile) {
            var basePath = '/order/order-confirmation';
            basePath = (isMobile) ? basePath + "-mobile?" : basePath + "?";
            var locationBase = this.activeOrder.locationBase;
            var orderId = this.activeOrder.id;
            var route = basePath + "lb=" + locationBase + "&order_id=" + orderId;
            return route;
        },
        fetchOrderGate: function (callback) {
            var _this = this;
            var fetchOrderCallback = function (response) {
                var data = response && response.data;
                var body = data && data.body;
                var order = body && body.order;
                if (order) {
                    _this.setOrder(body); // use parent object for re-constructing order
                    callback(true);
                    return;
                }
                callback(false);
            };
            this.getOrderFromService().then(fetchOrderCallback);
        } }),
    mounted: function () {
        var webSocket = this.websocket;
        if (!webSocket) {
            this.initializeTrackerWebSocket();
        }
    },
};
export default orderMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/orderMixin.ts
// module id = VcoQ
// module chunks = 18